import Swiper, { Autoplay, Navigation, EffectCreative } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

const productsSecEl = document.querySelector('.products-sec');

if (productsSecEl) {
  let productsTabsSwiperWr = productsSecEl.querySelectorAll('.products-tabs-swiper-wr');
  productsTabsSwiperWr.forEach((el) => {
    if (el) {
      let swiperEl = el.querySelector('.swiper');
      let wrapper = swiperEl.querySelector('.swiper-wrapper');

      const tabsButtonsArr = productsSecEl.querySelectorAll('.products-sec__tab');
      const tabsItemsArr = productsSecEl.querySelectorAll('.products-sec__item');

      if (tabsButtonsArr.length > 0 && !productsSecEl.querySelector('.products-sec__tab.is-active')) {
        tabsButtonsArr[0].classList.add('is-active');
      }

      if (tabsItemsArr.length > 0 && !productsSecEl.querySelector('.products-sec__item.is-active')) {
        tabsItemsArr[0].classList.add('is-active');
      }

      let swiper = new Swiper(swiperEl, {
        modules: [Autoplay, Navigation],
        observer: true,
        observeParents: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        threshold: 10,
      });

      let trackLine = document.createElement('div');
      trackLine.classList.add('products-sec__tabs-track');
      wrapper.appendChild(trackLine);

      let indicatorLine = document.createElement('div');
      indicatorLine.classList.add('products-sec__tabs-indicator');
      wrapper.appendChild(indicatorLine);

      const updateIndicator = (target) => {
        if (!target) return;
        const left = target.offsetLeft;
        const width = target.offsetWidth;
        indicatorLine.style.transform = `translateX(${left}px)`;
        indicatorLine.style.width = `${width}px`;
      };

      const productsTabsSelect = productsSecEl.querySelector('#products-tabs-select');

      tabsButtonsArr.forEach((btn, index) => {
        btn.addEventListener('mouseenter', () => updateIndicator(btn));

        btn.addEventListener('click', () => {
          tabsButtonsArr.forEach(b => b.classList.remove('is-active'));
          tabsItemsArr.forEach(item => item.classList.remove('is-active'));

          btn.classList.add('is-active');
          if (tabsItemsArr[index]) {
            tabsItemsArr[index].classList.add('is-active');
          }

          swiper.slideTo(index);
          updateIndicator(btn);

          // Синхронизация select, если он есть
          if (productsTabsSelect && window.setMetaSelectValue) {
            const optionIndex = index + (productsTabsSelect.options[0].value === '' ? 1 : 0);
            const option = productsTabsSelect.options[optionIndex];
            if (option) {
              window.setMetaSelectValue(productsTabsSelect.id, option.value);
            }
          }
        });
      });

      if (productsTabsSelect) {
        productsTabsSelect.addEventListener('change', () => {
          let selectedIndex = productsTabsSelect.selectedIndex;
          // Если первый элемент это плейсхолдер с value=""
          if (productsTabsSelect.options[0].value === '') {
            selectedIndex -= 1;
          }

          if (selectedIndex >= 0 && selectedIndex < tabsButtonsArr.length) {
            tabsButtonsArr.forEach(b => b.classList.remove('is-active'));
            tabsItemsArr.forEach(item => item.classList.remove('is-active'));

            tabsButtonsArr[selectedIndex].classList.add('is-active');
            if (tabsItemsArr[selectedIndex]) {
              tabsItemsArr[selectedIndex].classList.add('is-active');
            }

            swiper.slideTo(selectedIndex);
            updateIndicator(tabsButtonsArr[selectedIndex]);
          }
        });
      }

      wrapper.addEventListener('mouseleave', () => {
        const activeTab = productsSecEl.querySelector('.products-sec__tab.is-active');
        updateIndicator(activeTab);
      });

      setTimeout(() => {
        const activeTab = productsSecEl.querySelector('.products-sec__tab.is-active');
        updateIndicator(activeTab);
      }, 100);

      tabsItemsArr.forEach(itemEl => {
        let productsGallerySwiperWr = itemEl.querySelector('.products-gallery-swiper-wr');
        if (productsGallerySwiperWr) {
          let swiperEl = productsGallerySwiperWr.querySelector('.swiper');
          let nextEl = productsGallerySwiperWr.querySelector('.swiper-button-next');
          let prevEl = productsGallerySwiperWr.querySelector('.swiper-button-prev');
          let swiper = new Swiper(swiperEl, {
            modules: [Autoplay, Navigation, EffectCreative],
            observer: true,
            observeParents: true,
            spaceBetween: 24,
            slidesPerView: 1,
            threshold: 10,
            effect: 'creative',
            creativeEffect: {
              limitProgress: 10,
              prev: {
                translate: [0, 0, -400],
                opacity: 0.001,
                scale: 0.8,
              },
              next: {
                translate: ['calc(100% + 24px)', 0, 0],
              },
            },
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl,
            },
            breakpoints: {
              1023: {
                spaceBetween: 20,
                slidesPerView: 2,
                creativeEffect: {
                  limitProgress: 10,
                  prev: {
                    translate: [0, 0, -400],
                    opacity: 0.001,
                    scale: 0.8,
                  },
                  next: {
                    translate: ['calc(100% + 20px)', 0, 0],
                  },
                },
              },
              1200: {
                spaceBetween: 24,
                slidesPerView: 2,
                creativeEffect: {
                  limitProgress: 10,
                  prev: {
                    translate: [0, 0, -400],
                    opacity: 0.001,
                    scale: 0.8,
                  },
                  next: {
                    translate: ['calc(100% + 24px)', 0, 0],
                  },
                },
              },
            },
            autoplay: {
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: window.innerWidth >= 1033,
            }
          });

          swiperObserver(swiper);
        }
      });

    }
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const lazyImages = entry.target.querySelectorAll('img[loading="lazy"]');

      lazyImages.forEach(img => {
        if (img.src) {
          const currentSrc = img.src;
          img.src = '';
          img.loading = 'eager';
          img.src = currentSrc;
        }
      });

      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '200px',
    threshold: 0
  });

  observer.observe(productsSecEl);
}
